import {
  IRowPattern,
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
} from "@tedivo/tedivo-bay-grid-pure";

import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";
import { TSelectContainerCriteria } from "../useSimpleSideView";
import { getAllContainers } from "./getAllContainers";
import { getContainersByMaxSizePerStack } from "./getContainersByMaxSizePerStack";
import { getRowContainers } from "./getPerRowContainers";
import { getSideContainers } from "./getSideContainers";

export function obtainSideViewFilterFn(
  selectContainerCriteria: TSelectContainerCriteria,
): TObtainFilterFnOutput {
  switch (selectContainerCriteria) {
    case "maxSize":
      return getContainersByMaxSizePerStack;
    case "all":
      return getAllContainers;
    case "portOuter":
      return getSideContainers("port");
    case "stbdOuter":
      return getSideContainers("starboard");
    default:
      return getRowContainers(selectContainerCriteria as IRowPattern);
  }
}

type TObtainFilterFnOutput = (
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
) => TGetContainersFilterOutput;
